import React, { createContext, useState } from "react";

export const SearchFutureVocContext = createContext({});

export const initialSearchValues = {
  TypeFuture:"",
  industryType: "",
  quarter:"",
  yearOfBudget:"",
};

export const initialPageValues = {
  page: 0,
  pageSize: 10,
  total: 0,
  totalPage: 0,
  // sortBy: "departmentId",
  // sortDirection: "ASC",
};

const SearchFutureVocProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState(initialSearchValues);
  const [pageValues, setPageValues] = useState(initialPageValues);
  const [search, setSearch] = useState(true);

  return (
    <SearchFutureVocContext.Provider
      value={{
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
      }}
    >
      {children}
    </SearchFutureVocContext.Provider>
  );
};

export default SearchFutureVocProvider;
